module.exports = __webpack_public_path__ + "static/media/game-display-4@768.6febec6e.png";